/**
 * Function to format semiauth roles (remove `org` from displaying in portal)
 * @param role
 * @returns
 */
const format = (role: string) => role.replace(/org|\./g, " ").trim();

export default format;
